<div>
  <div>
    <div class="filter-content-container style2023">
      <form #form="ngForm" (ngSubmit)="search()" style="width: 100%" class="route-algo-admin-form">
        <div class="input-group">
          <div class="input-group-item">
            <i class="las la-search search-icon-resize"></i>
            <input
              pInputText
              name="searchSupplierName"
              style="width: 250px"
              type="text"
              class="filter-group-input-container-right input-group-filter"
              placeholder="Supplier Name"
              [(ngModel)]="this.filterVal.filters.supplierName.value"
            />
          </div>
        </div>

        <div class="input-group" style="width: 250px">
          <div class="input-group-item">
            <p-dropdown
              class="input-group-filter"
              name="orgStatus"
              placeholder="Select Organisation Status"
              [options]="orgStatusOptions"
              [(ngModel)]="filterVal.filters.organisationStatus.value"
            ></p-dropdown>
          </div>
        </div>

        <div class="input-group" style="width: 280px">
          <div class="input-group-item">
            <p-dropdown
              class="input-group-filter"
              name="plannedRoutesPortalEnabled"
              placeholder="Filter Planned Routes Enabled (Portal)"
              [options]="enabledOptions"
              [(ngModel)]="filterVal.filters.plannedRoutesEnabled.value"
            ></p-dropdown>
          </div>
        </div>

        <div>
          <button
            pButton
            type="submit"
            label="Search"
            [disabled]="form.invalid"
            class="button-style btn-md ui-primary-button ml-0"
            icon="fa ui-icon-search"
          ></button>
          <button
            pButton
            type="button"
            icon="fa ui-icon-restore"
            class="button-style btn-md ui-tertiary-button ml-2"
            (click)="resetFilters(dt)"
          ></button>
        </div>
      </form>
    </div>
    <div class="content-container" style="margin-bottom: 20px">
      <p-table
        #dt
        [value]="page.items"
        [lazy]="true"
        [rows]="itemsPerPageDef"
        [paginator]="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        [(selection)]="selectedOrganisation"
        rowHover="true"
        selectionMode="single"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="supplierName">Supplier Name</th>
            <th>Email Address</th>
            <th>Organisation Status</th>
            <th>Status</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td style="overflow-x: hidden">{{ item.name }}</td>
            <td>{{ item.emailAddress }}</td>
            <td style="text-align: center">{{ item.organisationStatus }}</td>
            <td style="text-align: center">
              {{ item.plannedRoutesEnabled ? 'Enabled' : 'Disabled' }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="planned-route-access-footer">
        <button
          type="button"
          pButton
          [label]="
            selectedOrganisation && selectedOrganisation.plannedRoutesEnabled
              ? 'Disable Planned Routes'
              : 'Enable Planned Routes'
          "
          [ngClass]="
            selectedOrganisation && selectedOrganisation.plannedRoutesEnabled
              ? 'btn-to-right ui-button-danger'
              : 'btn-to-right ui-button-success'
          "
          [disabled]="!selectedOrganisation"
          (click)="toggleEnabledStatus()"
        ></button>
      </div>
    </div>
  </div>
</div>
